import api from "@modules/api/api";
import { useMutation } from "@tanstack/react-query";

interface UpdateUserLanguageRequest {
  locale: string;
  dealId?: string;
}

const putUpdateUserLangugage = async ({
  locale,
  dealId,
}: UpdateUserLanguageRequest) => {
  const searchParams = new URLSearchParams();

  if (dealId) {
    searchParams.append("dealId", dealId);
  }

  return api.rawPut("api/accounts/language", {
    headers: { "Accept-Language": locale },
    searchParams,
  });
};

export default function useUpdateUserLanguageMutation() {
  return useMutation({ mutationFn: putUpdateUserLangugage });
}
